/**
 * Paleta con hues bien separados, asignados por posición (no por nombre) — con varios turnos
 * de nombres parecidos (ej. varios "Turno Diurno X"), colorear por palabra clave del nombre
 * los deja a todos con el mismo color; colorear por posición garantiza que turnos distintos
 * se vean distintos.
 *
 * Compartida por "Configuración de horario de trabajo por proyecto" y "Programación masiva de
 * horarios": ambas pantallas listan los mismos turnos diarios del proyecto (misma llamada
 * api/WorkShift/Project/{id}, mismo filtro y mismo orden), así que usar esta misma función con
 * el índice del turno en esa lista les da siempre el mismo color en ambas pantallas.
 */
export const TURNO_COLOR_PALETTE = [
  '#8B98E8', // azul-lavanda
  '#4FB6A0', // verde-azulado
  '#4A4090', // morado oscuro
  '#C2569D', // magenta
  '#C99A3E', // ámbar
  'dodgerblue',
  '#C97B63', // terracota
  '#7CB342', // verde oliva
  '#D4756B', // coral
  '#6C7BC4', // índigo
  '#3FA66B', // verde
  '#E0834A', // naranja
  '#7C8798'  // gris azulado
];

export function colorForTurnoIndex(index: number): string {
  return TURNO_COLOR_PALETTE[index % TURNO_COLOR_PALETTE.length];
}
